export default {
    methods: {
        l() {
            if (process.env.VUE_APP_EXEC_MODE === 'dev') {
                console.log(...arguments)
            }
        },
        fakeAsync: function(payload = null) {
            return new Promise((resolve, reject) => {
                let ratio = [true, true, true, false] // 75% ratio for correct response
                const roll = Math.round(Math.random() * 100)
                let option = ratio[Math.trunc(roll / 25)]
                setTimeout(() => {
                    if (option) {
                        resolve({
                            status: 'success',
                            code: '200',
                            data: payload,
                        })
                    } else {
                        reject({
                            response: {
                                status: 'error',
                                code: '402',
                                data: {
                                    message: 'FAKEASYNC ERROR',
                                },
                            },
                        })
                    }
                }, 500)
            })
        },
    },
}
